// @ts-nocheck
import React from "react";
import TagsList, { QueryTagsList } from "components/Tags/TagsList/TagsList";
import genRequest from "includes/request";
import { fetchPostCategories } from "classes/Posts/postCategories";

export default function PostCategories(props) {

	const {post} = props;

	if (props.categories)
	{
		return (
			<TagsList
				items={props.categories}
			/>
		);
	}
	return (
		<QueryTagsList
			queryKey={
				(props.animationId) ?
					["Categories", "CategoriesOfAnimation", props.animationId]
					:
					["Categories", "Post", post.id]
			}
			queryFn={
				(props.animationId) ?
					() => genRequest("categories/animation/" + props.animationId)
					:
					() => fetchPostCategories(post.id)
			}
			queryOptions={{
				enabled: (post?.id ? true : false),
				retry: 1,
			}}
		/>
	);
}
